import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Script from "next/script";
var isProduction = process.env["STAGE_NAME"] === "production";
var scripts = {
    development: "https://scripts.simpleanalyticscdn.com/latest.dev.js",
    production: "https://scripts.simpleanalyticscdn.com/latest.js"
};
export function SimpleAnalyticsScripts() {
    var hostname = isProduction ? "www.cinch.co.uk" : "cambridge.preview.aws.cinch.co.uk";
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Script, {
                id: "SA",
                src: isProduction ? scripts["production"] : scripts["development"],
                strategy: "beforeInteractive",
                "data-allow-params": "CID",
                "data-hostname": hostname
            }),
            /*#__PURE__*/ _jsx("noscript", {
                children: /*#__PURE__*/ _jsx("img", {
                    src: "https://queue.simpleanalyticscdn.com/noscript.gif?hostname=".concat(hostname),
                    alt: "",
                    referrerPolicy: "no-referrer-when-downgrade"
                })
            })
        ]
    });
}
